var _g, _g2, _g3, _g4, _g5, _g6, _g7;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatistics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_003-stats",
    "data-name": "003-stats",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.235,
    height: 23.449,
    viewBox: "0 0 24.235 23.449",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15",
    "data-name": "Grupo 15",
    transform: "translate(10.098 8.506)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_14",
    "data-name": "Grupo 14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_814",
    "data-name": "Caminho 814",
    d: "M203.635,176.232H200.4a.4.4,0,0,0-.4.4v11.309a.4.4,0,0,0,.4.4h3.231a.4.4,0,0,0,.4-.4V176.636A.4.4,0,0,0,203.635,176.232Zm-.4,11.309h-2.423v-10.5h2.423Z",
    transform: "translate(-200 -176.232)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17",
    "data-name": "Grupo 17",
    transform: "translate(19.792 6.89)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16",
    "data-name": "Grupo 16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_815",
    "data-name": "Caminho 815",
    d: "M395.635,144.232H392.4a.4.4,0,0,0-.4.4v12.925a.4.4,0,0,0,.4.4h3.231a.4.4,0,0,0,.4-.4V144.636A.4.4,0,0,0,395.635,144.232Zm-.4,12.925h-2.423V145.04h2.423Z",
    transform: "translate(-392 -144.232)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_19",
    "data-name": "Grupo 19",
    transform: "translate(14.945 15.776)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_18",
    "data-name": "Grupo 18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_816",
    "data-name": "Caminho 816",
    d: "M299.635,320.232H296.4a.4.4,0,0,0-.4.4v4.039a.4.4,0,0,0,.4.4h3.231a.4.4,0,0,0,.4-.4v-4.039A.4.4,0,0,0,299.635,320.232Zm-.4,4.039h-2.423V321.04h2.423Z",
    transform: "translate(-296 -320.232)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_21",
    "data-name": "Grupo 21",
    transform: "translate(0.404 10.121)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_20",
    "data-name": "Grupo 20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_817",
    "data-name": "Caminho 817",
    d: "M11.635,208.232H8.4a.4.4,0,0,0-.4.4v9.694a.4.4,0,0,0,.4.4h3.231a.4.4,0,0,0,.4-.4v-9.694A.4.4,0,0,0,11.635,208.232Zm-.4,9.694H8.808V209.04h2.423Z",
    transform: "translate(-8 -208.232)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_23",
    "data-name": "Grupo 23",
    transform: "translate(5.251 12.545)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_22",
    "data-name": "Grupo 22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_818",
    "data-name": "Caminho 818",
    d: "M107.635,256.232H104.4a.4.4,0,0,0-.4.4v7.27a.4.4,0,0,0,.4.4h3.231a.4.4,0,0,0,.4-.4v-7.27A.4.4,0,0,0,107.635,256.232Zm-.4,7.27h-2.423V257.04h2.423Z",
    transform: "translate(-104 -256.232)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_25",
    "data-name": "Grupo 25",
    transform: "translate(0.806 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_24",
    "data-name": "Grupo 24"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_819",
    "data-name": "Caminho 819",
    d: "M37,7.768a1.627,1.627,0,0,0-1.125,2.814l-3.352,6.149a1.483,1.483,0,0,0-.921.042l-3.119-4.68a1.616,1.616,0,1,0-2.656-.382l-2.452,2.041A1.594,1.594,0,0,0,21.225,14l-2.056-1.028a1.641,1.641,0,1,0-.367.72l2.056,1.028a1.616,1.616,0,1,0,3.033-.349l2.452-2.041a1.561,1.561,0,0,0,1.468.21l3.118,4.68a1.616,1.616,0,1,0,2.3-.1l3.352-6.149a1.593,1.593,0,0,0,.394.052A1.627,1.627,0,0,0,37,7.768ZM17.59,13.446a.808.808,0,1,1,.808-.808A.808.808,0,0,1,17.59,13.446Zm4.847,2.423a.808.808,0,1,1,.808-.808A.808.808,0,0,1,22.437,15.87Zm4.847-4.039a.808.808,0,1,1,.808-.808A.808.808,0,0,1,27.283,11.831ZM32.13,19.1a.808.808,0,1,1,.808-.808A.808.808,0,0,1,32.13,19.1Zm4.847-8.886a.808.808,0,1,1,.808-.808A.808.808,0,0,1,36.977,10.215Z",
    transform: "translate(-15.973 -7.768)"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_27",
    "data-name": "Grupo 27",
    transform: "translate(0 21.027)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_26",
    "data-name": "Grupo 26"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_820",
    "data-name": "Caminho 820",
    d: "M23.831,424.232H.4a.4.4,0,0,0-.4.4v1.616a.4.4,0,0,0,.4.4H23.831a.4.4,0,0,0,.4-.4v-1.616A.4.4,0,0,0,23.831,424.232Zm-.4,1.616H.808v-.808H23.427Z",
    transform: "translate(0 -424.232)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatistics);
export default __webpack_public_path__ + "static/media/statistics.c3c81d7cd1eac31008b437cb21250a55.svg";
export { ForwardRef as ReactComponent };